import { render, staticRenderFns } from "./DashboardClientRedirectUri.vue?vue&type=template&id=69adf271&"
import script from "./DashboardClientRedirectUri.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientRedirectUri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69adf271')) {
      api.createRecord('69adf271', component.options)
    } else {
      api.reload('69adf271', component.options)
    }
    module.hot.accept("./DashboardClientRedirectUri.vue?vue&type=template&id=69adf271&", function () {
      api.rerender('69adf271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientRedirectUri.vue"
export default component.exports